import { createRouter, createWebHistory } from "vue-router";
import { authHelper } from "@/utils/auth"; // Asumiendo que tienes este helper

// Vistas
import Login from "@/views/pages/auth/login.vue";
import AdminLayout from "@/views/pages/dashboard/index.vue";
import Home from "@/views/pages/dashboard/home.vue";
import Category from "@/views/pages/dashboard/product/category.vue";
import SubCategory from "@/views/pages/dashboard/product/sub-category.vue";
import Product from "@/views/pages/dashboard/product/product.vue";
import listProducts from "@/views/pages/dashboard/product/listProducts.vue";
import galeryProduct from "@/views/pages/dashboard/product/galeryProduct.vue";
import editProduct from "@/views/pages/dashboard/product/editProduct.vue";
import proveedor from "@/views/pages/dashboard/compra/proveedor.vue";
import compra from "@/views/pages/dashboard/compra/compra.vue";
import consultaCompra from "@/views/pages/dashboard/compra/consultaCompra.vue";
import consultaVenta from "@/views/pages/dashboard/venta/consultaVenta.vue";
import consultaAnual from "@/views/pages/dashboard/consulta/consultaAnual.vue";
import consultaInventario from "@/views/pages/dashboard/consulta/consultaInventario.vue";
import consultaProductosMes from "@/views/pages/dashboard/consulta/consultaProductosMes.vue";
import Perfil from "@/views/pages/dashboard/perfil.vue";
import Usuario from "@/views/pages/dashboard/usuario/usuario.vue";

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true } // Marcar ruta pública
  },
  {
    path: '',
    component: AdminLayout,
    redirect: '/home',
    meta: { requiresAuth: true }, // Proteger todas las rutas hijas
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { title: 'Inicio' }
      },
      {
        path: 'perfil',
        name: 'perfil',
        component: Perfil,
        meta: { title: 'Mi Perfil' }
      },
      {
        path: 'usuario',
        name: 'usuario',
        component: Usuario,
        meta: { title: 'Usuarios' }
      },
      {
        path: 'product/category',
        name: 'category',
        component: Category,
        meta: { title: 'Categorias' }
      },
      {
        path: 'product/subcategory',
        name: 'subcategory',
        component: SubCategory,
        meta: { title: 'Sub Categorias' }
      },
      {
        path: 'product/list',
        name: 'listProduct',
        component: listProducts,
        meta: { title: 'Lista Productos' }
      },
      {
        path: 'product/product',
        name: 'product',
        component: Product,
        meta: { title: 'Crear Producto' }
      },
      {
        path: 'product/galery/:id',
        name: 'galeryProduct',
        component: galeryProduct,
        meta: { title: 'Galeria Producto' }
      },
      {
        path: 'product/edit/:id',
        name: 'editProduct',
        component: editProduct,
        meta: { title: 'Editar Producto' }
      },  
      {
        path: 'compra/proveedor',
        name: 'proveedor',
        component: proveedor,
        meta: { title: 'Proveedores' }
      },    
      {
        path: 'compra/compra',
        name: 'compra',
        component: compra,
        meta: { title: 'Ingresar Compra' }
      },
      {
        path: 'compra/consulta',
        name: 'consultaCompra',
        component: consultaCompra,
        meta: { title: 'Consulta de Compras' }
      },
      {
        path: 'venta/consulta',
        name: 'consultaVenta',
        component: consultaVenta,
        meta: { title: 'Consulta de Ventas' }
      },
      {
        path: 'consulta/anual',
        name: 'consultaAnual',
        component: consultaAnual,
        meta: { title: 'Consulta por Año' }
      },
      {
        path: 'consulta/inventario',
        name: 'consultaInventario',
        component: consultaInventario,
        meta: { title: 'Consulta de Inventario' }
      },
      {
        path: 'consulta/productos-mes',
        name: 'consultaProductosMes',
        component: consultaProductosMes,
        meta: { title: 'Productos Vendidos por Mes' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home' 
  }
];

export const router = createRouter({
  history: createWebHistory("/"),
  linkActiveClass: "active",
  routes,
});

// Guard de navegación global
router.beforeEach((to, from, next) => {
  // Scroll to the top of the page
  window.scrollTo({ top: 0, behavior: "smooth" });

  // Manejo de clases para páginas especiales
  if (to.name === "chat") {
    document.body.classList.add("chat-page");
  } else {
    document.body.classList.remove("chat-page");
  }

  // Verificación de autenticación
  const isPublic = to.matched.some(record => record.meta.public);
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // Si la ruta requiere autenticación y el token está expirado
  if (requiresAuth && authHelper.isTokenExpired()) {
    // Limpiar credenciales y redirigir a login
    localStorage.removeItem('credentials');
    return next({
      path: '/login',
      query: { redirect: to.fullPath, sessionExpired: true }
    });
  }

  // Si ya está autenticado y trata de acceder a login
  if (to.path === '/login' && !authHelper.isTokenExpired()) {
    return next('/home');
  }

  // Establecer título de la página si está definido en meta
  if (to.meta.title) {
    document.title = `${to.meta.title} | Panel de Tienda`;
  }

  next();
});
